import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-retraits',
    templateUrl: './retraits.component.html',
    styleUrls: ['./retraits.component.css'],
    standalone: false
})
export class RetraitsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
